import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import ManageProfile from './Component/ManageProfile';
import Phi from './../../Phi/Phi'

const getFormDefs = (organization, contactNo) => ({
  inOrganizationName: organization.inOrganizationName,
  inOrganizationAddress: organization.inOrganizationAddress,
  countryName: organization.countryName,
  stateName: organization.stateName,
  cityName: organization.cityName,
  emailId: Phi.User.profile().username,
  organizationPincode: organization.inOrganizationCustomJson.organizationPincode,
  contactNo: contactNo,
})

const formatOrganization = (data) => ({
  inOrganizationName: data.inOrganizationName,
  inOrganizationAddress: data.inOrganizationAddress,
  inOrganizationCustomJson: {schoolContactPersonDetails: data.schoolContactPersonDetails}
})

const mapStateToProps = (state, ownProps) => {
  const program = state.organization && state.organization.programs && state.organization.programs.length && state.organization.programs[0] || null
  const contactNo = program && program.organization_custom_json && program.organization_custom_json.schoolContactPersonDetails.length && program.organization_custom_json.schoolContactPersonDetails[0] && program.organization_custom_json.schoolContactPersonDetails[0].contactNo || null
  const userRole =  Phi.User.roles()
  return {
    inOrganizationId: program && program.id,
    organization: state.organization.currentOrganization,
    formData: Object.keys(state.organization.currentOrganization).length ? getFormDefs(state.organization.currentOrganization, contactNo) : null,
    schoolContactPersonDetails: program && program.organization_custom_json && program.organization_custom_json.schoolContactPersonDetails || null,
    roleType: userRole && userRole.length && userRole[0].role_type_id
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    initializeForm: (data) => dispatch(Actions.initializeForm(data)),
    updateOrganization: (orgId, orgData) => dispatch(Actions.updateOrganization(orgId, formatOrganization(orgData))),
    getOrg: (orgId) => dispatch(Actions.getOrganization(orgId))
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(ManageProfile)